<template>
    <v-dialog v-model="dialog" :max-width="options.width" :style="{ zIndex: options.zIndex }" @keydown.esc="cancel">
        <v-card>
            <v-toolbar dark :class="'bg-' + options.confirmColor"  dense flat>
                <v-toolbar-title class="white--text">{{ title }}</v-toolbar-title>
            </v-toolbar>

            <v-card-text v-show="!!message" class="pa-4">
                <div v-html="message"></div>

                <div v-if="hideNext">
                    <v-checkbox v-model="hideForFuture" label="Ne plus afficher pour les prochaines fois">
                    </v-checkbox>
                </div>

                <div v-if="confirmWord !== null">
                    <v-text-field v-model="confirmMessage" outlined autofocus hide-details>
                    </v-text-field>
                </div>
            </v-card-text>

            <v-card-actions class="pt-0">
                <v-spacer></v-spacer>
                <v-btn @click.native="cancel">
                    Annuler</v-btn>
                <v-btn class="default-button" :class="'custom-button-' + options.confirmColor" @click.native="agree"
                    :disabled="!isValidConfirmation">
                    Confirmer
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapMutations, mapState } from "vuex"

export default {
    props: ['hideNext', 'backgroundTitle'],
    data: () => ({
        dialog: false,
        resolve: null,
        reject: null,
        message: null,
        title: null,
        confirmWord: null,
        options: {
            color: 'error',
            width: 400,
            zIndex: 200,
            backgroundTitle: 'error',
            confirmColor: 'error'
        },
        hideForFuture: false,
        confirmMessage: null
    }),
    methods: {
        ...mapMutations('web_form', ['setHideNextModal']),
        open(title, message, options, confirmWord = null) {
            this.dialog = true
            this.title = title
            this.message = message
            this.confirmWord = confirmWord

            this.options = Object.assign(this.options, options)
            return new Promise((resolve, reject) => {
                this.resolve = resolve
                this.reject = reject
            })
        },
        agree() {
            this.resolve(true)

            if (this.hideNext !== undefined) {
                this.setHideNextModal(this.hideForFuture)
            }

            this.dialog = false
        },
        cancel() {
            this.resolve(false)
            this.dialog = false
        }
    },
    computed: {
        ...mapState('web_form', ['hideNextModal']),
        isValidConfirmation() {
            return this.confirmWord === null || (this.confirmMessage === this.confirmWord)
        }
    },
    created() {
        if (this.backgroundTitle !== undefined) {
            this.options.backgroundTitle = this.backgroundTitle
        }
    }
}
</script>